export default __webpack_public_path__ + "static/media/feu_pre.9199ed73.jpg";